import Vue from 'vue'

// Global event bus used to trigger the session-expired modal from the axios
// interceptors, which live outside the Vue component tree.
export const sessionBus = new Vue()
